import { ForecastCell } from "./forecastCell.model";

export class FbForecast {
  fbForecastSelectedId!: any;
  itemIds!: string;
  channelIds!: string;
  calendarIds!: string;
  userId!: number;
  userFBForecastId!: number;
  versionTypeId!: number;
  fbTemplateId?: number;
  [key: string]: any;
  fbForecasts!: Array<ForecastCell>;
  fbweeks?: Array<any>;
  weeks?: Array<any>;
  constructor(forecast?: FbForecast) {
      this.itemIds = forecast?.itemIds || '';
      this.fbForecastSelectedId = forecast?.fbForecastSelectedId || 0;
      this.channelIds = forecast?.channelIds || '';
      this.calendarIds = forecast?.calendarIds || '';
      this.userId = forecast?.userId || 0;
      this.userFBForecastId = forecast?.userFBForecastId || 0;
      this.versionTypeId = forecast?.versionTypeId || 2;
      this.fbForecasts = forecast?.fbForecasts || [];
      this.fbweeks = forecast?.fbweeks || [];
      this.weeks = forecast?.weeks || [];

  }
}
